import React, { Component } from 'react';
import _ from 'lodash';
import ReactIScroll from 'react-iscroll';
import iScroll from 'iscroll';
import shared from '../../../utils/shared.js';
import BRSpan from '../../General/BRSpan';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
const QuillDeltaToHtmlConverter = require('quill-delta-to-html');

class VideoSeattle extends Component {
  constructor(props) {
    super(props);
    this._imagesStatus = [];
    this._contentRef = null;
    this._textContentRef = null;
    this._videoOverlay = null;
    this._videoRef = null;
    this._playerInitialized = false;

    this.state = {
      videoOffsetY: 0,
      videoOffsetX: 0,
      showVideo: 0,
      paused: true
    };
  }

  componentDidMount() {
    this.intervalCheckSwipeAnimation();
    this.initPlayer();
  }

  componentDidUpdate() {
    if (this._playerInitialized) {
      const videoHeight = this._videoRef.getBoundingClientRect().height;
      const videoWidth = this._videoRef.getBoundingClientRect().width;

      this.setState({
        videoHeight: videoHeight,
        videoWidth: videoWidth
      });
      this._playerInitialized = false;
    }
  }

  intervalCheckSwipeAnimation = () => {
    if (!this._contentRef) {
      setTimeout(() => {
        this.intervalCheckSwipeAnimation();
      }, 100);
    } else {
      this.checkSwipeAnimation();
    }
  }

  checkSwipeAnimation = () => {
    let scrollWrapperHeight = 0.14625 * this.props.regionWidth;
    let contentHeight = this._textContentRef.getBoundingClientRect().height;
    this.props.handleSwipeAnimation(scrollWrapperHeight, contentHeight);
  }

  handleScrollStart = () => {
    this.props.cancelSwipeAnimation();
  }

  initPlayer = () => {
    this._videoRef.addEventListener('loadedmetadata', this.loadedMetadata);
    this._videoRef.addEventListener('loadeddata', this.loadedData);
    this._videoRef.addEventListener('ended', this.videoEnded);
  }

  handleVideoPlay = () => {
    if (this.state.paused) {
      this._videoRef.play();
    } else {
      this._videoRef.pause();
    }
    this.setState({
      paused: !this.state.paused
    });
  }

  loadedMetadata = () => {
    this._metadataLoaded = true;
    this.checkIfAllDataLoaded();
  }

  loadedData = () => {
    this._dataLoaded = true;
    this.checkIfAllDataLoaded();
  }

  videoEnded = () => {
    this.setState({
      paused: true
    })
  }

  checkIfAllDataLoaded = () => {
    if (this._metadataLoaded && this._dataLoaded) {
      this.positionVideo();
      this._playerInitialized = true;
      this.setState({
        showVideo: 1
      });
    }
  }

  positionVideo = () => {
    if (!this._videoRef) {
      setTimeout(() => {
        this.positionVideo();    
      }, 100);
      return;
    }

    let videoHeight = this._videoRef.getBoundingClientRect().height;
    let videoWidth = this._videoRef.getBoundingClientRect().width;
    let videoOffsetX = (this._contentRef.getBoundingClientRect().width - videoWidth) / 2;

    this.setState({
      videoHeight: videoHeight,
      videoWidth: videoWidth,
      videoOffsetX: videoOffsetX,
    });
  }

  render() {
    let _videoStyle = {
      preload: 'auto',
      position: 'absolute',
      maxWidth: '80%',
      maxHeight: '70%',
      muted: "",
    }

    if (this.props.screensNumber === 2){
      _videoStyle.maxWidth = '40%'
    }

    let cType = shared.videoType(this.props.item.contents.images[0].file_name);
    let videoSrc = shared.dp(this.props.screen, this.props.item.contents.images[0]);
    const showVideo = this.state.showVideo ? 1 : 0;
    const showPlayButton = this.state.paused && this.state.showVideo ? 1 : 0;
    let textOps = _.get(this.props.item.contents, 'custom_fields.body.val.ops', {});
    let converter = new QuillDeltaToHtmlConverter(textOps, {}); 
    let richText = converter.convert();
    
    return (
      <div ref={el => this._contentRef = el} style={{ position:"absolute", display:"table", height:"100%", width:"100%" }}>
        <div style={{ display:"table-cell", verticalAlign:"middle" }}>
          <div style={{ width:"100%", alignItems:"center", display:"flex", justifyContent:"center", textAlign:"center", minHeight:.027 * this.props.regionWidth, maxHeight: .10 * this.props.regionWidth, overflow:"hidden", marginBottom: 0.015625 * this.props.regionWidth }}>
            <span className="noselect" style={{ fontSize: 0.016875 * this.props.regionWidth, width:"65%" }}><BRSpan preWrap str={this.props.item.name.toUpperCase()} /></span>
          </div>
          <div style={{ height: this.state.videoHeight }}>
            <CSSTransitionGroup
              component='div'
              className="slowfadedelay"
              style={{ minHeight: '100%' }}
              transitionName='example'
              transitionEnterTimeout={0}
              transitionLeaveTimeout={0}>
                <div className="seattle-video">
                  <video className="videopills" style={{ ..._videoStyle, left: this.state.videoOffsetX, opacity: showVideo }} ref={el => this._videoRef = el}>
                    <source src={videoSrc} type={cType} />
                    Your browser does not support the video tag.
                  </video>
                  {/* <div style={{ backgroundColor: "white", opacity: 0.5, position: "absolute", width: this.state.videoWidth, height: this.state.videoHeight, left: this.state.videoOffsetX }}/> */}
                  <div onClick={() => this.handleVideoPlay()} ref={el => this._videoOverlay = el} style={{ position: "absolute", width: this.state.videoWidth, height: this.state.videoHeight, left: this.state.videoOffsetX, display: "flex", justifyContent:"center", alignItems: "center", opacity: showPlayButton, }}>
                    <img src="/img/ui/play.png" style={{ width: 0.1041 * this.props.regionWidth, height: 0.1041 * this.props.regionWidth }} alt=""/>
                  </div>
                </div>
            </CSSTransitionGroup >
          </div>
          <div className="gradient" style={{ position: "relative", height: 0.14625 * this.props.regionWidth, width: "100%", touchAction: "none", marginTop: .009 * this.props.regionWidth }}>
            <ReactIScroll ref={el => this.iScroller = el} iScroll={iScroll}
              onScrollStart={this.handleScrollStart}
              options={{
                mouseWheel: true,
                scrollbars: false,
                scrollX: false,
                scrollY: true,
                probeType: 2,
                bounce: false,
                momentum: true,
                deceleration: 0.015,
                useTransition: true,
                disableTouch: false,
                disablePointer: false,
                disableMouse: false,
                tap: true
              }}
            >
              <div style={{ position: "relative", display: "flex", justifyContent: "center" }} ref={el => this._textContentRef = el}>
                <div style={{ width: 0.30375 * this.props.regionWidth, display: "flex" }}>
                  <span style={{ fontSize: 0.01125 * this.props.regionWidth, textAlign: "left", lineHeight: 0.0225 * this.props.regionWidth + "px", color: "white" }}>
                    <div className="ql-editor noselect" dangerouslySetInnerHTML={{ __html: richText }}></div>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                </div>
              </div>
            </ReactIScroll>
          </div>
        </div>
      </div>
    );
  }
}

export default VideoSeattle;


// WEBPACK FOOTER //
// ./src/Components/Theme/Seattle/VideoSeattle.jsx